"use client"

import { reopenConsentBanner } from "@/lib/analytics"

/** Footer-Link, der das Cookie-Banner erneut öffnet (DSGVO: Widerruf jederzeit). */
export default function CookieSettingsLink() {
  return (
    <button
      onClick={reopenConsentBanner}
      className="text-left text-sm hover:text-[var(--main-color)] transition-colors"
    >
      Cookie-Einstellungen
    </button>
  )
}
